// Copyright © 2019-2026 Focal Systems. All rights reserved.

// openapi-fetch never throws — it returns `{ data, error, response }`. The backend
// reports failures with a JSON envelope (`{ status, code, errors: [{ type, detail }] }`),
// but the back-office OpenAPI spec only documents it via examples, so it isn't a
// generated type. This module turns that loose shape into a typed error callers can
// branch on (status code, error type, human-readable detail).

interface ApiErrorEnvelope {
  status?: string;
  code?: number;
  errors?: Array<{ type?: string; detail?: string; msg?: string }>;
}

export class ApiError extends Error {
  constructor(
    message: string,
    /** HTTP status of the response (e.g. 409, 422). */
    public status: number,
    /** Backend error type of the first error, e.g. "value_error.missing". */
    public type?: string,
    /** Backend detail string of the first error, e.g. "chain.chainName:test". */
    public detail?: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

/** Turn an openapi-fetch non-2xx result into an ApiError carrying status + first error detail. */
export function toApiError(error: unknown, response: Response, fallback: string): ApiError {
  const envelope = error as ApiErrorEnvelope | undefined;
  const first = envelope?.errors?.[0];
  const detail = first?.detail ?? first?.msg;
  return new ApiError(detail ?? fallback, response.status, first?.type, detail);
}
